/**
 * Game Board Preview component - displays drop-zone buttons above each column
 */

import React from 'react';
import { EyeTrackableButton } from './eye-trackable-button';
import './game-board-preview.scss';

interface IGameBoardPreviewProps {
  currentPlayer: 1 | 2;
  isGameActive: boolean;
  onColumnClick: (column: number) => void;
  isColumnAvailable: (column: number) => boolean;
}

export const GameBoardPreview: React.FC<IGameBoardPreviewProps> = ({
  currentPlayer,
  isGameActive,
  onColumnClick,
  isColumnAvailable,
}) => {
  const handleColumnClick = (column: number) => {
    if (isGameActive && isColumnAvailable(column)) {
      onColumnClick(column);
    }
  };

  return (
    <div className='game-board-preview'>
      {Array.from({ length: 7 }, (_, colIndex) => {
        const available = isGameActive && isColumnAvailable(colIndex);
        return (
          <EyeTrackableButton
            key={`preview-${colIndex}`}
            className={`game-board-preview__drop-zone ${available ? '' : 'game-board-preview__drop-zone--disabled'}`}
            onClick={() => handleColumnClick(colIndex)}
            disabled={!available}
            variant='preview'
            data-gaze-region='true'
            data-gaze-region-margin='3vw 0vw 0vw'
            data-testid={`preview-button-${colIndex}`}
            ariaLabel={`Drop piece in column ${colIndex + 1}`}
          >
            <div className='game-board-preview__drop-zone-content'>
              <div
                className={`game-board-preview__piece ${available ? `game-board-preview__piece--player-${currentPlayer}` : 'game-board-preview__piece--empty'}`}
              />
              <span className='game-board-preview__label'>{colIndex + 1}</span>
            </div>
          </EyeTrackableButton>
        );
      })}
    </div>
  );
};
